// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3JVEE","inputWrap":"CustomTip_inputWrap__2qRHK"};